import React from 'react'
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FaFileDownload } from "react-icons/fa";
import fin from '../controller/api/Financ'
import user from '../controller/api/User'
import { BsClockHistory } from "react-icons/bs";

const ModalDownNF = ({ id }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const [nf, setNf] = useState([])
    const Fin = new fin()
    const User = new user


    const handleShow = () => {
        if (id != 0) {
            Fin.getNF(id)
                .then(response => {
                    if (response) {
                        setNf(response);
                    } else {
                        setNf([]);
                    }
                })
                .catch(err => console.log(err));
        }
        setShow(true)
    }

    const handleDownload = (id, nome) => {
        User.download(id, nome)
    };

    return (
        <>
            <button onClick={handleShow} className='w-50 btn btn-outline-secondary d-flex justify-content-center aling-items-center'> <FaFileDownload /></button>

            <Modal show={show} size="lg" centered onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Nota Fiscal</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <table className=' border table table-nf-main table-hover table-bordered'>

                        {
                            nf?.length > 0 ?
                                (nf?.map((newNf, index) => (
                                    <React.Fragment key={index}>
                                        <tbody>
                                            <tr>
                                                <td className=' table-nf' onClick={() => handleDownload(newNf?.nota_fiscal?.ID_nota_fiscal, newNf?.nota_fiscal?.Nome)}>{newNf?.nota_fiscal?.Nome}</td>
                                            </tr>
                                        </tbody>
                                    </React.Fragment>
                                )))
                                :
                                (<tbody>
                                    <tr>
                                        <td className='d-flex align-items-center'> <BsClockHistory style={{ marginRight: "5px" }} />Aguardando Documento...</td>
                                    </tr>
                                </tbody>)
                        }
                    </table>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}> Fechar </Button>

                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalDownNF